"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Kiramune Digital Collection',
    organizationId: 'y43HTnZNX6sA1C2Lsutv',
    applicationKey: 'kiramune',
    applicationType: 'organization',
    artistId: undefined,
    ionicAppId: 'f8f2ad58',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.kiramune',
        appId: '6497652875',
    },
    android: {
        bundleId: 'com.utoniq.kiramune',
    },
    deeplinkUrl: 'https://kiramune.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3562292',
    deeplinkProd: 'kiramune.utoniq.com',
    custom: {
        modules: {
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            liveStream: true,
            item: true,
            store: true,
            campaign: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'myCollections', 'campaign-events'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'threads'],
    },
});
